import { StepsProps } from '@commons/steps/types.ts'
import SectionHeader from '@commons/section-header/SectionHeader.tsx'
import {
    Carousel,
    CarouselItem,
    Icon
} from '@nespresso-design-system/components'
import styles from './Steps.module.scss'
import { sanitizeHtml } from '@content/helpers/src/utils.ts'
import { useEffect, useState } from 'preact/hooks'

export function useIsMobile(breakpoint = 768): boolean {
    const [isMobile, setIsMobile] = useState(() =>
        typeof window !== 'undefined' ? window.innerWidth <= breakpoint : false
    )

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= breakpoint)
        }

        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [breakpoint])

    return isMobile
}

const Steps = ({ heading = '', items = [] }: StepsProps) => {
    const isMobile = useIsMobile()

    return (
        <section className={styles.steps}>
            <SectionHeader headline={heading} align="center" />

            {isMobile ? (
                <section className={styles.steps__container__mobile}>
                    <Carousel>
                        {items.map((step, index) => (
                            <CarouselItem
                                key={`step-${index}`}
                                aria-labelledby={`step-title-mobile-${index}`}>
                                <div className={styles.step}>
                                    <div className={styles.step__icon}>
                                        <Icon icon={step.picto} method="mask" />
                                    </div>
                                    <div className={styles.step__title}>
                                        <h3 id={`step-title-mobile-${index}`}>
                                            {step.heading}
                                        </h3>
                                    </div>
                                    <div className={styles.step__description}>
                                        <p
                                            dangerouslySetInnerHTML={{
                                                __html: sanitizeHtml(
                                                    step.description
                                                )
                                            }}
                                        />
                                    </div>
                                </div>
                            </CarouselItem>
                        ))}
                    </Carousel>
                </section>
            ) : (
                <div className={styles.steps__container__desktop}>
                    <div className={styles.steps__container}>
                        <ol className={styles.steps__list}>
                            {items.map((step, index) => (
                                <li key={index} className={styles.step}>
                                    <Icon
                                        className={styles.step__icon}
                                        icon={step.picto}
                                        method="mask"
                                    />
                                    <div className={styles.step__title}>
                                        <h3 id={`step-title-desktop-${index}`}>
                                            {step.heading}
                                        </h3>
                                    </div>
                                    <div className={styles.step__description}>
                                        <p
                                            dangerouslySetInnerHTML={{
                                                __html: sanitizeHtml(
                                                    step.description
                                                )
                                            }}
                                        />
                                    </div>
                                </li>
                            ))}
                        </ol>
                    </div>
                </div>
            )}
        </section>
    )
}

export default Steps
